<template>
  <div>
    <vxe-modal v-model="dialogVisible" title="万金油余额回收" width="600" height="240" :before-close="close" resize>
      <el-form ref="form" :rules="rules" :model="form" label-width="200">
        <!-- <el-form-item label="选择授权企业万金油账户" prop="authorizeZzNumber">
          <el-cascader
            v-model="company"
            style="max-width:99%;"
            :options="authorizeCompanyOptions"
            @change="handleCompany"
          />
        </el-form-item> -->
        <el-form-item label="品类" prop="category">
          <el-select
            v-model="form.category"
            style="width:90%;"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="close">取 消</el-button>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import { getAuthorizeCompany,recoveryBackMoney }  from '@/api/userOil'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      company:[],
      categoryOptions:[
        {value:'1',label: '柴油'},
        {value:'2',label: '天然气'}
      ],
      form:{
        name:'',
        username:'',
        // remark:'',
        // authorizeZzNumber:'',
        // authorizeCuId:'',
      },
      authorizeCompanyOptions: [],
      // 校验
      rules: {
        authorizeZzNumber: [
          { required: true, message: "选择授权企业万金油账户", trigger: "change" },
        ],
      }
    }
  },
  created() {
  },
  methods: {
    show(item) {
      this.form = {
        name:'',
        username:'',
        remark:'',
        // authorizeZzNumber:'',
        // authorizeCuId:'',
      }
      // this.getAuthorizeCompany(item.branchCode)
      this.company = []
      this.form.username = item.phone
      this.form.name = item.name
      this.dialogVisible = true
    },
    // 关闭
    close() {
      this.dialogVisible = false
    },
    // 万金油余额回收
    submit() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading('正在处理中...')
          recoveryBackMoney(this.form).then(response => {
            this.$message({ message: response.msg, type: "success" })
            rLoading.close()
            this.dialogVisible = false
          });
        }
      });
    },
    handleCompany(value) {
      this.form.authorizeZzNumber = value[0]
      this.form.authorizeCuId = value[1]
    },
    getAuthorizeCompany(branchCode){
      return getAuthorizeCompany({
        page:1, 
        pageSize: 500,
        receiptCode:'',
        branchCode: branchCode
      }).then((response) => {
        let data = response.data
        data.authorizeCompanyList.forEach(item=>{
          let obj = {
            value:item.zzNumber,
            label:item.companyName,
          }
          if(item.accountList) {
            let children = []
            item.accountList.forEach(account=>{
              children.push({
                value:account.cuId,
                label:account.fuelType
              })
            })
            obj.children = children
            this.authorizeCompanyOptions.push(obj)
          }
        })
      })
    }
  }
}
</script>
<style scoped lang="scss"></style>
